import { Card, CardContent } from "../../../../../../components/ui/card";

export const AlignmentTab: React.FC = () => {
  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-medium">Alignment</h3>
        {/* Alignment content will be added here */}
      </CardContent>
    </Card>
  );
}; 